module.exports = __webpack_public_path__ + "static/media/afl-desktop.c45bebd3.jpg";